<footer class="footer ">
  <div class="container-fluid">
    <div class="copyright pull-center">Copyright &copy;
      {{test | date: 'yyyy'}}
      <a href="javascript:void(0);" class="custom-footer-link-style">ER GROUP TECHNOLOGY</a>. All rights reserved
    </div>
  </div>
</footer>